export default "__VITE_ASSET__a0b1115f__"